import {
  pageFlag,
  sendStatus,
  sendXtStatus,
  sendOutBound,
  receiveInBound,
  receiveStatus,
  receiveXtStatus
} from "./statusData";

export const sendButtonData = {
  accept: {
    name: '接受收货结果',
    btnType: 'success',
    val: 'accept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return (sendStatus.reviewed.val == status.val || sendStatus.closed.val == status.val)
        && sendXtStatus.receivingException.val == xtStatus.val
    },
    onPress(bound, status, xtStatus) {
      xtStatus.val = xtStatus.receivingConfirmException.val
    },
  },
  confirmAccept: {
    name: '确认收货结果',
    btnType: 'success',
    val: 'confirmAccept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return (sendStatus.reviewed.val == status.val || sendStatus.closed.val == status.val)
        && sendXtStatus.receivingConfirmException.val == xtStatus.val
    },
    onPress(bound, status, xtStatus) {
      xtStatus.val = sendXtStatus.complete.val

      receiveXtStatus.val = receiveXtStatus.complete.val
    },
  },
  refuse: {
    name: '拒绝收货结果',
    btnType: 'success',
    val: 'refuse',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return (sendStatus.reviewed.val == status.val
        && (sendXtStatus.receivingException.val == xtStatus.val
          || sendXtStatus.receivingConfirmException.val == xtStatus.val
        ))

        || (sendStatus.closed.val == status.val && (sendXtStatus.receivingException.val == xtStatus.val
          || sendXtStatus.receivingConfirmException.val == xtStatus.val
        ))
    },
    onPress(bound, status, xtStatus) {
      xtStatus.val = sendXtStatus.refuse.val

      receiveXtStatus.val = receiveXtStatus.receivingRejectionException.val
    },
  },

  cancelAccept: {
    name: '取消接受',
    btnType: 'primary',
    val: 'cancelAccept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    onPress(bound, status, xtStatus) {
      console.log('点击了')
    },
  },
  edit: {
    name: '编辑',
    btnType: 'primary',
    val: 'edit',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val || sendXtStatus.refuse.val == xtStatus.val)
        && sendButtonData.save.isPress == true && sendButtonData.edit.isPress == false
    },
    onPress(bound, status, xtStatus) {
    },
  },
  save: {
    name: '保存',
    btnType: 'primary',
    val: 'save',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val || sendXtStatus.refuse.val == xtStatus.val)
        && sendButtonData.save.isPress == false
    },
    onPress(bound, status, xtStatus) {

      console.log('点击了')
    },
  },
  saveAdd: {
    name: '保存并新增',
    btnType: 'primary',
    val: 'saveAdd',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val || sendXtStatus.refuse.val == xtStatus.val)
        &&   sendButtonData.save.isPress == false
    },
    onPress(bound, status, xtStatus) {

      console.log('点击了')
    },
  },
  verify: {
    name: '审核',
    btnType: 'primary',
    val: 'verify',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && sendXtStatus.uncooperative.val == xtStatus.val
    },
    onPress(bound, status, xtStatus) {
      status.val = status.reviewed.val
      xtStatus.val = xtStatus.uncooperative.val
      //console.log('点击了')
    },
  },
  verifyAdd: {
    name: '审核并新增',
    btnType: 'primary',
    val: 'verifyAdd',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && sendXtStatus.uncooperative.val == xtStatus.val
    },
    onPress(bound, status, xtStatus) {
      //console.log('点击了')
      // status.val = status.reviewed.val
      // xtStatus.val = xtStatus.uncooperative.val
    },
  },
  del: {
    name: '删除 D',
    btnType: 'primary',
    val: 'del',
    canClick:true , isPress: false, effect: 'light', tooltipMsg: '当前单据存在被审核过，取消审核回来的不可删除此单据', check(bound, status, xtStatus) {
      return sendStatus.review.val == status.val
        && sendXtStatus.uncooperative.val == xtStatus.val
    },
    onPress(bound, status, xtStatus) {
      console.log('点击了')
    },
  },
  eidtSend: {
    name: '编辑发货',
    btnType: 'primary',
    val: 'eidtSend',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    onPress(bound, status, xtStatus) {
      console.log('点击了')
    },
  },
  push: {
    name: '推送',
    btnType: 'success',
    val: 'push',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return (sendStatus.reviewed.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val || sendXtStatus.refuse.val == xtStatus.val))
        || (sendStatus.closed.val == status.val
          && sendXtStatus.uncooperative.val == xtStatus.val || sendXtStatus.refuse.val == xtStatus.val)
    },
    onPress(bound, status, xtStatus) {
      status.val = status.reviewed.val
      xtStatus.val = xtStatus.receiving.val
      //影响对方
      receiveStatus.val = receiveStatus.empty.val
      receiveXtStatus.val = receiveXtStatus.receiving.val
    },
  },
  cancelVerify: {
    name: '取消审核',
    btnType: 'primary',
    val: 'cancelVerify',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendStatus.reviewed.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val
          || sendXtStatus.refuse.val == xtStatus.val)
    },
    onPress(bound, status, xtStatus) {
      status.val = status.review.val
      xtStatus.val = xtStatus.uncooperative.val
    },
  },
  outBound: {
    name: '出库',
    btnType: 'primary',
    val: 'outBound',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return (sendStatus.reviewed.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val
          || sendXtStatus.receiving.val == xtStatus.val
          || sendXtStatus.complete.val == xtStatus.val))
    },
    onPress(bound, status, xtStatus) {
      bound.val = sendOutBound.yes.val
    },
  },
  cancel: {
    name: '取消',
    btnType: 'success',
    val: 'cancel',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: ''
    ,
    check(bound, status, xtStatus) {
      return sendOutBound.no.val == bound.val
        && (sendStatus.reviewed.val == status.val
        && (sendXtStatus.receiving.val == xtStatus.val
          || sendXtStatus.refuse.val == xtStatus.val)
        || sendXtStatus.complete.val == xtStatus.val)
    },
    onPress(bound, status, xtStatus) {
      status.val = status.cancel.val
      xtStatus.val = xtStatus.cancel.val

      receiveStatus.val = receiveStatus.cancel.val
      receiveXtStatus.val = receiveXtStatus.cancel.val
    },
  },
  closed: {
    name: '关闭',
    btnType: 'primary',
    val: 'closed',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendOutBound.yes.val == bound.val && sendStatus.reviewed.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val
          || sendXtStatus.receiving.val == xtStatus.val
          || sendXtStatus.complete.val == xtStatus.val)
    },
    onPress(bound, status, xtStatus) {
      status.val = status.closed.val
      //console.log('点击了')
    },
  },
  activation: {
    name: '激活',
    btnType: 'primary',
    val: 'activation',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendOutBound.yes.val == bound.val && sendStatus.closed.val == status.val
        && (sendXtStatus.uncooperative.val == xtStatus.val
          || sendXtStatus.refuse.val == xtStatus.val
          || sendXtStatus.receiving.val == xtStatus.val
          || sendXtStatus.complete.val == xtStatus.val)
    },
    onPress(bound, status, xtStatus) {
      status.val = status.reviewed.val
    }
  },
  copy: {
    name: '复制',
    btnType: 'primary',
    val: 'copy',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return !sendButtonData.edit.isPress
    },
    onPress(bound, status, xtStatus) {
    },
  },
  gift: {
    name: '赠品',
    btnType: 'primary',
    val: 'gift',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return sendButtonData.save.isPress==false
    },
    onPress(bound, status, xtStatus) {
    },
  },
  print: {
    name: '打印',
    btnType: 'primary',
    val: 'print',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
  previous: {
    name: '<',
    btnType: '',
    val: 'previous',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '',
    check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
  next: {
    name: '>',
    btnType: '',
    val: 'next',
    canClick: false , isPress: false, effect: 'dark', tooltipMsg: '',
    check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
}

export const receiveButtonData = {
  receiveSendEqual: {
    name: '收货数量=发货数量',
    val: 'receiveSendEqual',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return receiveButtonData.verifyConfirmAccept.isPress
    },
    btnType: 'success',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.reviewed.val
      xtStatus.val = receiveXtStatus.complete.val

      sendXtStatus.val = sendXtStatus.complete.val
    },
  },
  receiveSendNotEqual: {
    name: '收货数量≠发货数量',
    val: 'receiveSendNotEqual',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return receiveButtonData.verifyConfirmAccept.isPress
    },
    btnType: 'success',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.reviewed.val
      xtStatus.val = receiveXtStatus.receivingException.val

      sendXtStatus.val = sendXtStatus.receivingException.val
    },
  },
  verifyConfirmAccept: {
    name: '审核 M',//审核并确认收货 鼠标移上去需要能按钮提示
    val: 'verifyConfirmAccept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '审核后系统会自动将收货情况推送给对方。', check(bound, status, xtStatus) {
      return !receiveButtonData.verifyConfirmAccept.isPress &&
        status.val == receiveStatus.review.val
        && (xtStatus.val == receiveXtStatus.receiving.val || xtStatus.val == receiveXtStatus.confirmReceiving.val)
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },
  save: {
    name: '保存',
    val: 'save',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return !receiveButtonData.verifyConfirmAccept.isPress && status.val == receiveStatus.review.val && xtStatus.val == receiveXtStatus.receiving.val
        || receiveButtonData.edit.isPress
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      //待审核和待本方收货情况
      if (status.val == receiveStatus.review.val && xtStatus.val == receiveXtStatus.receiving.val) {
        xtStatus.val = receiveXtStatus.confirmReceiving.val
      }

    },
  },
  accept: {
    name: '收货',
    val: 'accept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return !receiveButtonData.accept.isPress &&
        !receiveButtonData.verifyConfirmAccept.isPress &&
          (status.val == receiveStatus.empty.val
          && xtStatus.val == receiveXtStatus.receiving.val)
          // || (status.val == receiveStatus.review.val && xtStatus.val == receiveXtStatus.receivingRejectionException.val
          //   || xtStatus.val == receiveXtStatus.confirmReceiving.val
          // ))
    },
    btnType: 'success',
    onPress(bound, status, xtStatus) {
      if (status.val == receiveStatus.empty.val) {
        status.val = receiveStatus.review.val
        xtStatus.val = receiveXtStatus.receiving.val
      }
    },
  },
  edit: {
    name: '编辑',
    val: 'edit',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return !receiveButtonData.edit.isPress &&
        !receiveButtonData.verifyConfirmAccept.isPress &&
        (
          (status.val == receiveStatus.review.val && xtStatus.val == receiveXtStatus.receivingRejectionException.val
            || xtStatus.val == receiveXtStatus.confirmReceiving.val
          ))
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
        // status.val = receiveStatus.review.val
        // xtStatus.val = receiveXtStatus.receiving.val
    },
  },
  editRelation: {
    name: '对应货品',
    val: 'editRelation',
    canClick:true , isPress: false, effect: 'light', tooltipMsg: '', check(bound, status, xtStatus) {
      return false //被编辑替代了
      // !receiveButtonData.accept.isPress &&
      //   !receiveButtonData.verifyConfirmAccept.isPress &&
      //   status.val == receiveStatus.review.val &&
      //   (xtStatus.val == receiveXtStatus.receiving.val || xtStatus.val == receiveXtStatus.receivingRejectionException.val
      //     || xtStatus.val == receiveXtStatus.confirmReceiving.val
      //   )
        // || status.val == receiveStatus.reviewed.val
        // && (xtStatus.val == receiveXtStatus.complete.val
        //   || xtStatus.val == receiveXtStatus.receivingException.val
        //   || xtStatus.val == receiveXtStatus.receivingRejectionException.val)
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },
  verify: {
    name: '审核 M',
    val: 'verify',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '审核后系统会自动将收货情况推送给对方。', check(bound, status, xtStatus) {
      return status.val == receiveStatus.review.val && xtStatus.val == receiveXtStatus.receivingRejectionException.val
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.reviewed.val
      xtStatus.val = receiveXtStatus.receivingException.val

      sendXtStatus.val = sendXtStatus.receivingException.val
    },
  },

  refuse: {
    name: '拒收',
    val: 'refuse',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return !receiveButtonData.verifyConfirmAccept.isPress &&
        (status.val == receiveStatus.empty.val || status.val == receiveStatus.review.val
          && (xtStatus.val == receiveXtStatus.receiving.val || xtStatus.val == receiveXtStatus.confirmReceiving.val))
    },
    btnType: 'success',
    onPress(bound, status, xtStatus) {
      xtStatus.val = receiveXtStatus.refuse.val

      sendXtStatus.val = sendXtStatus.refuse.val
    },
  },
  confirmAccept: {
    name: '确认接受',
    val: 'confirmAccept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },

  cancelAccept: {
    name: '取消接受',
    val: 'cancelAccept',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },

  del: {
    name: '删除',
    val: 'del',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },

  eidtIn: {
    name: '收货',
    val: 'eidtIn',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },
  push: {
    name: '推送--此按钮已取消，由上个流程审核自动推',
    val: 'push',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false;//status.val == receiveStatus.reviewed.val && xtStatus.val == receiveXtStatus.receivingRejectionException.val
    },
    btnType: 'success',
    onPress(bound, status, xtStatus) {
      xtStatus.val = receiveXtStatus.receivingException.val

      sendXtStatus.val = sendXtStatus.receivingException.val
    },
  },
  cancelVerify: {
    name: '取消审核',
    val: 'cancelVerify',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return status.val == receiveStatus.reviewed.val && xtStatus.val == receiveXtStatus.receivingRejectionException.val
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.review.val
    },
  },
  inBound: {
    name: '入库',
    val: 'inBound',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return status.val == receiveStatus.reviewed.val
        && (xtStatus.val == receiveXtStatus.receivingException.val
          || xtStatus.val == receiveXtStatus.receivingRejectionException.val
          || xtStatus.val == receiveXtStatus.complete.val
        )
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      bound.val = receiveInBound.yes.val
    },
  },
  cancel: {
    name: '取消',
    val: 'cancel',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return false
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {

    },
  },
  closed: {
    name: '关闭',
    val: 'closed',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return bound.val == receiveInBound.yes.val && status.val == receiveStatus.reviewed.val && xtStatus.val == receiveXtStatus.complete.val
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.closed.val
    },
  },
  activation: {
    name: '激活',
    val: 'activation',
    canClick:true , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return bound.val == receiveInBound.yes.val && status.val == receiveStatus.closed.val && xtStatus.val == receiveXtStatus.complete.val
    },
    btnType: 'primary',
    onPress(bound, status, xtStatus) {
      status.val = receiveStatus.reviewed.val
      //status.val = receiveStatus.reviewed.val
    },
  },
  gift: {
    name: '赠品 D',
    btnType: 'primary',
    val: 'gift',
    canClick:false , isPress: false, effect: 'light', tooltipMsg: '协同接收方不可显示，只有在新增情况下可以显示！', check(bound, status, xtStatus) {
      return receiveButtonData.accept.isPress
    },
    onPress(bound, status, xtStatus) {
    },
  },
  print: {
    name: '打印',
    btnType: 'primary',
    val: 'print',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '', check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
  previous: {
    name: '<',
    btnType: '',
    val: 'previous',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '',
    check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
  next: {
    name: '>',
    btnType: '',
    val: 'next',
    canClick:false , isPress: false, effect: 'dark', tooltipMsg: '',
    check(bound, status, xtStatus) {
      return true
    },
    onPress(bound, status, xtStatus) {
    },
  },
}



// WEBPACK FOOTER //
// ./src/data/btnData.js